import type { AudioGroup } from '|>/shared/types/audio'

import { atmosCodecsSubstrings } from './lib'

export function parseMpdForAtmosAudio(masterManifest: string): AudioGroup[] {
  if (!masterManifest) return []
  const atmosGroups: AudioGroup[] = []

  const parser = new DOMParser()
  const xmlDoc = parser.parseFromString(masterManifest, 'text/xml')

  const allAdaptationSets = Array.from(xmlDoc.all).filter((element) => {
    return element.tagName === 'AdaptationSet'
  })

  allAdaptationSets.forEach((adaptationSet) => {
    const codecs = adaptationSet.getAttribute('codecs')?.toLowerCase() || ''
    const id = adaptationSet.id || ''

    const isAtmos = atmosCodecsSubstrings.some((codec) => {
      const isCodec = codecs.toLowerCase().includes(codec)
      // NOTE. Duplicated AdaptationSets may have children SupplementalProperty that has word "Joc", not clear should it be check or not
      // Api handles duplicated sets as one.

      // const isJoc = Array.from(adaptationSet.getElementsByTagName('SupplementalProperty')).some(prop => {
      //   const value = prop.getAttribute('value')
      //   return value?.toLowerCase() === 'joc'
      // })
      return isCodec
    })

    if (isAtmos) {
      const audioGroup: AudioGroup = {
        language: adaptationSet.getAttribute('lang') || '',
        uri: adaptationSet.getAttribute('baseURL') || '',
        name: adaptationSet.getAttribute('id') || id,
      }
      atmosGroups.push(audioGroup)
    }
  })

  return atmosGroups
}
